import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/pools/incheon/page.tsx");
